/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-06-23 11:16:30
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-09-15 11:12:47
 * @FilePath: /zljzz_mall_h5/src/router/@route/coupon.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const MODEL_NAME = 'coupon'
export default [
  {
    path: `/${MODEL_NAME}/list`,
    name: 'couponList',
    component: () => import(/* webpackChunkName: "coupon-list" */ '@pages/coupon/list/index.vue')
  },
  {
    path: `/${MODEL_NAME}/square`,
    name: 'couponSquare',
    component: () =>
      import(/* webpackChunkName: "coupon-square" */ '@pages/coupon/square/index.vue')
  },
  {
    path: `/${MODEL_NAME}/history`,
    name: 'history',
    component: () => import(/* webpackChunkName: "coupon" */ '@pages/coupon/history/index.vue')
  }
]
